export default __webpack_public_path__ + "static/media/im-img.e0776422.webp";